module.exports = __webpack_public_path__ + "img/32.2.TN.dd0a83e3.png";